/* tslint:disable */
/* eslint-disable */
/**
 * Control Online API
 * Control Online API
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
import {
  DeferredIncomeDto,
  DeferredIncomeDtoFromJSON,
  DeferredIncomeDtoFromJSONTyped,
  DeferredIncomeDtoToJSON,
} from "./DeferredIncomeDto";
import {
  FinancialPlanFundAfterDto,
  FinancialPlanFundAfterDtoFromJSON,
  FinancialPlanFundAfterDtoFromJSONTyped,
  FinancialPlanFundAfterDtoToJSON,
} from "./FinancialPlanFundAfterDto";
import {
  FinancialPlanFundBeforeDto,
  FinancialPlanFundBeforeDtoFromJSON,
  FinancialPlanFundBeforeDtoFromJSONTyped,
  FinancialPlanFundBeforeDtoToJSON,
} from "./FinancialPlanFundBeforeDto";

/**
 *
 * @export
 * @interface FinancialPlanDeferredIncomeDto
 */
export interface FinancialPlanDeferredIncomeDto {
  /**
   *
   * @type {string}
   * @memberof FinancialPlanDeferredIncomeDto
   */
  id: string;
  /**
   *
   * @type {DeferredIncomeDto}
   * @memberof FinancialPlanDeferredIncomeDto
   */
  deferredIncome: DeferredIncomeDto;
  /**
   *
   * @type {FinancialPlanFundBeforeDto}
   * @memberof FinancialPlanDeferredIncomeDto
   */
  before: FinancialPlanFundBeforeDto;
  /**
   *
   * @type {FinancialPlanFundAfterDto}
   * @memberof FinancialPlanDeferredIncomeDto
   */
  after: FinancialPlanFundAfterDto;
}

export function FinancialPlanDeferredIncomeDtoFromJSON(json: any): FinancialPlanDeferredIncomeDto {
  return FinancialPlanDeferredIncomeDtoFromJSONTyped(json, false);
}

export function FinancialPlanDeferredIncomeDtoFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): FinancialPlanDeferredIncomeDto {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    id: json["id"],
    deferredIncome: DeferredIncomeDtoFromJSON(json["deferredIncome"]),
    before: FinancialPlanFundBeforeDtoFromJSON(json["before"]),
    after: FinancialPlanFundAfterDtoFromJSON(json["after"]),
  };
}

export function FinancialPlanDeferredIncomeDtoToJSON(value?: FinancialPlanDeferredIncomeDto | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    id: value.id,
    deferredIncome: DeferredIncomeDtoToJSON(value.deferredIncome),
    before: FinancialPlanFundBeforeDtoToJSON(value.before),
    after: FinancialPlanFundAfterDtoToJSON(value.after),
  };
}
